import { DeliveryPromiseTypes, DeliveryTypes, StockLevels } from "@utils/enums";

const getHomeDeliveryKey = (subject: string) => {
    return `${subject}.deliveryPromise.homeDelivery`;
};

export const determineDeliveryTimeTranslationKey = (
    deliveryType?: string,
    stockLevel?: string | null,
    realTimeStockAvailable?: boolean,
    realTimeStock?: number
): void | string => {
    // Bij homedelivery moet stock level genegeerd worden
    if (deliveryType === DeliveryTypes.HomeDelivery) {
        return getHomeDeliveryKey("pdp");
    }

    if (deliveryType === DeliveryPromiseTypes.AvailableForS2S) {
        return "pdp.deliveryPromise.shipToStore";
    } else if (
        (!realTimeStockAvailable && stockLevel === null) ||
        (!realTimeStockAvailable && stockLevel === StockLevels.NoStock) ||
        (!realTimeStockAvailable && stockLevel === StockLevels.UnknownStock) ||
        (realTimeStockAvailable && realTimeStock! <= 0)
    ) {
        return "pdp.deliveryPromise.noStock";
    }

    if (deliveryType === DeliveryPromiseTypes.OnlyAvailableOffline && realTimeStockAvailable) {
        return "pdp.deliveryPromise.onlyAvailableOffline.realTimeStock";
    }

    if (realTimeStockAvailable) {
        return "pdp.deliveryPromise.clickAndCollect.realTimeStock";
    }

    if (deliveryType === DeliveryPromiseTypes.OnlyAvailableOffline) {
        return "pdp.deliveryPromise.onlyAvailableOffline";
    }

    if (deliveryType === DeliveryPromiseTypes.AvailableForPickUpInStore) {
        if (stockLevel === StockLevels.LowStock) {
            return "pdp.deliveryPromise.clickAndCollect.lowStock";
        } else {
            return "pdp.deliveryPromise.clickAndCollect.default";
        }
    }
};

export const cartDeliveryPromiseTranslationKey = (
    deliveryPromise?: any,
    deliveryType?: DeliveryTypes,
): string => {
    let cartDeliveryPromiseTranslationKey = "cart.deliveryPromise.noStock";

    if (
        deliveryPromise &&
        deliveryPromise.deliveryPromiseType === DeliveryPromiseTypes.NoStock &&
        !!deliveryPromise.withRemove
    ) {
        cartDeliveryPromiseTranslationKey =
            "cart.deliveryPromise.noStockAndRemove";
    }

    if (
        deliveryPromise &&
        deliveryPromise.deliveryPromiseType !== DeliveryPromiseTypes.NoStock
    ) {
        if (deliveryType === DeliveryTypes.ClickAndCollect) {
            cartDeliveryPromiseTranslationKey =
                "cart.deliveryPromise.clickAndCollect.default";
        } else if (deliveryType === DeliveryTypes.HomeDelivery) {
            cartDeliveryPromiseTranslationKey = getHomeDeliveryKey("cart");
        }
    }

    return cartDeliveryPromiseTranslationKey;
};
